var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { ITEM_PREFIXES } from '../../../constants';
export const ListContext = createContext({
    flattenItems: {},
    focusFlattenItems: {},
    firstItemId: ITEM_PREFIXES.default,
});
export function useNewListContext() {
    return useContext(ListContext);
}
function extractListProps({ size, marker, flattenItems, focusFlattenItems, contentRender, firstItemId, }) {
    return { size, marker, contentRender, flattenItems, focusFlattenItems, firstItemId };
}
export function NewListContextProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return _jsx(ListContext.Provider, { value: extractListProps(props), children: children });
}
